<template lang="pug">
.entity-list
  component(
    v-if="!!$replasable(entity.name, parent, relation.multiple)",
    :is="$replasable(entity.name, parent, relation.multiple)",
    v-bind="{ ...$props, path, invert, parent, parentInstance, parentPath }",
    :entity="entity",
    fromList,
  )
  .entity-list.pa-5(v-else)
    //- If isSection prop is received, not show the title neither the description
    v-row.mb-5(v-if="!isASection()")
      v-col.d-flex(cols="8")
        h2.primary--text {{ getLabel.replace(/_/g, " ") }}
    v-row(v-if="!isASection()")
      v-col.py-0
        h4.entity__subtitle {{ loGet(entity, 'description') }}
    v-row(v-if="errors && errors[path]")
      v-input(:error="!!errors[path]", :error-messages="errors[path]")
        template(v-slot:message)
          h2.py-2(v-for="e in errors[path]") {{ e }}
    v-row
      v-col.d-flex.justify-end
        v-tooltip(right)
          template(v-slot:activator="{ on }")
            //- If isSection prop is received, show the add button to the level where the component starts
            v-btn.add-entity-button(v-if="!isASection()", @click="pushToArray", fab, x-small, color="primary", v-on="on")
              v-icon mdi-plus
            v-btn(v-else, @click="pushToArray", fab, x-small, color="primary", v-on="on")
              v-icon mdi-plus
          span {{ $t('Common.addEntity', { entity: $tCheckC(`${entityName}._name`, $pascalToHuman(entityName), 1)}) }}
    .d-flex.justify-end.align-center
      .actions
        a(@click="mode = 'table'")
          v-icon(:color="mode === 'table' ? 'geoBlue' : 'grey'") mdi-table
        a(@click="mode = 'list'")
          v-icon(:color="mode === 'list' ? 'geoBlue' : 'grey' ") mdi-view-list
    .entity-table(v-if="mode === 'table'")
      g-data-table(
        :headers="$fieldsToHeaders(entity, fields)",
        :items="instance"
      )
    template(v-if="mode === 'list'")
      template(v-for="(index, i) in instance")
        app-entity(
          v-if="isNotDeleted(index)",
          :extra-data="extraData",
          :chips="chips",
          @close="setAsDeleted($event, i, index)",
          :path="`${path}[${i}]`",
          :parentPath="`${path}`",
          :entity="$findEntity(relation.type)",
          fromList,
          :key="index.__id || index.id",
          :elementIndex="i",
          :visibleIndex="findVisibleIndex(index)",
          v-bind="{ ...$attrs, parent, selectorOnly, showInfo, relation, isActive, modalInstance }",
        )
          template(v-for="(_, slot) in $slots")
            template(:slot="slot")
              slot(:name="slot")
</template>

<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parentPath', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isSection', 'isActive'],
  data: function () {
    return {
      key: 0,
      mode: 'list'
    }
  },
  computed: {
    entityName() {
      return _.get(this.entity, 'name');
    },
    getLabel() {
      const relationName = _.get(this.relation, 'name');
      const parentName = _.get(this.parent, 'name');
      const customLabelObj = this.$getCustomLabel(parentName) || {};
      const labelAttribute = relationName || this.entityName;

      const customLabel = _.get(customLabelObj, labelAttribute);
      if(customLabel) return this.$camelToString(this.$displayName(customLabel));

      if (relationName) {
        const translated = this.$tCheckC(`${parentName}.${relationName}`, '');
        if (!_.isEmpty(translated)) return translated;
      }

      return this.$camelToString(this.$displayName(labelAttribute));
    },
    errors() {
      return this.$store.state.errors;
    },
    visibleElements() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
  },
  methods: {
    pushToArray() {
      const copyInstance = _.cloneDeep(this.instance);
      copyInstance.push({__id: this.$uid() , entityState: 4, _Entity: this.entity.name});
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: copyInstance });
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    // If this property receive the prop isSection return true, else return false, function to validate if
    //the prop isSection has been received as prop
    isASection() {
      if(this.isSection == null || this.isSection == 'false') return false;
      return true;
    },
    loGet(obj, path, baseValue = null) {
      return _.get(obj, path, baseValue);
    },
    setAsDeleted (instance, i, element) {
      if (instance && instance.id)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 })
      else if (!instance && element)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 })
      else {
        this.instance.splice(i, 1)
      }
      // this.resetIndexes()
      this.key++;
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    findVisibleIndex(element) {
      if (!this.visibleElements) return null;
      return this.visibleElements.findIndex(vp => {
        if (element && element.id) return vp.id === element.id
        if (element && element.__id) return vp.__id === element.__id
      });
    },
  },
}
</script>
